<template>
  <c-row>
    <c-col col="6">
    <loading v-show="loading" />
      <c-card>
        <c-card-header>
          <strong>Add Customer</strong>
        </c-card-header>
        <c-card-body>
          <add-customer :data="customer" :errors="hasError"/>
        </c-card-body>
        <c-card-footer>
          <sur-button @onSave="save" @onUpdate="update" @onReset="reset" :object="customer" />
        </c-card-footer>
      </c-card>
    </c-col>
  </c-row>
</template>
<script>
import Loading from "../../components/Loading";
import SURButton from "../../components/SURButton";
import { HTTPAUTH } from "../../lib/httplib";
import AddCustomer from './components/AddCustomer.vue';
export default {
  name: "CustomerAdd",
  components: {
    "sur-button": SURButton,
    Loading,
    AddCustomer
  },
  data() {
    return {
      customer: {
        type: null,
        customer_id: ""
      },
      hasError: {},
      loading: false
    };
  },
  created() {
    const query = this.$route.query;
    if (query.id) {
      this.get(query.id);
    }
  },
  methods: {
    save() {
      this.customer.type_id = this.customer.type ? this.customer.type.id : null;
      HTTPAUTH.post("/api/v1/customer", this.customer)
        .then(() => {
          this.$toasted.success("Data berhasil disimpan").goAway(1000);
          this.reset();
        })
        .catch(eres => {
          console.log(eres.response.data);
          if (eres.response.data.user_message) {
            this.$toasted.error(eres.response.data.user_message).goAway(3000);
            return;
          }
          this.hasError = eres.response.data.errors;
          this.$toasted.error(eres.response.data.message).goAway(3000);
        });
    },
    get(id) {
      HTTPAUTH.get("/api/v1/customer/" + id).then(res => {
        this.customer = res.data.data;
      });
    },
    update() {
      this.customer.type_id = this.customer.type ? this.customer.type.id : null;
      HTTPAUTH.put("/api/v1/customer/" + this.customer.id, this.customer)
        .then(() => {
          this.$toasted.success("Data berhasil disimpan").goAway(1000);
          this.reset();
        })
        .catch(eres => {
          console.log(eres.response.data);
          if (eres.response.data.user_message) {
            this.$toasted.error(eres.response.data.user_message).goAway(3000);
            return;
          }
          this.hasError = eres.response.data.errors;
          this.$toasted.error(eres.response.data.message).goAway(3000);
        });
    },
    reset() {
      this.customer = {};
      this.$router.push({query: {}})
    },
  }
}
</script>
